export default {
  name: "McTableCol",
  props: {
    label: {
      type: String,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: "auto"
    }
  }
};